module.exports = __webpack_public_path__ + "img/n1.3138bf22.jpg";